import React, {useContext} from "react";
import {FormattedMessage} from "react-intl";

import UIPopupContext from "../../popups/UIPopup/UIPopupContext";
import TextInput from "../../ui/textInput";
import {setAiDisableReferenceImage} from "../aiActions";
import {useAppDispatch, useAppSelector} from "../../../storeHooks";

const selectModelItems = [
  {value: "gpt-5.1-chat-latest", text: "GPT 5.1 (Chat Latest)"},
  {value: "gpt-5.1", text: "GPT 5.1 Thinking"},
  {value: "gpt-5-nano", text: "GPT-5 Nano (Fastest)"},
  {value: "gpt-5-mini", text: "GPT-5 Mini (Balanced)"},
  {value: "gpt-5", text: "GPT-5 (Best Quality)"},
  {value: "gpt-4o-mini", text: "GPT-4o Mini (Legacy Fast)"},
  {value: "gpt-4o", text: "GPT-4o (Legacy High Quality)"},
  {value: "custom", text: "Custom..."},
]

const selectImageItems = [
  {value: "gpt-image-1", text: "GPT Image 1"},
  {value: "gpt-image-1.5", text: "GPT Image 1.5"},
  {value: "custom", text: "Custom..."},
]

export default function UiPopupAIContentDropdowns() {

  const { aiDisableReferenceImage } = useAppSelector(state => state.aiState);
  const dispatch = useAppDispatch();

  const ctx = useContext(UIPopupContext);
  if (!ctx) {
    return null
  }

  const { uiPopupContext, uiPopupDispatch } = ctx;
  const { selectedChatModel, customChatModel, selectedImageModel, customImageModel } = uiPopupContext;

  const onModelChange = (event) => {
    console.log("event.target.value", event.target.value);
    uiPopupDispatch({
      selectedChatModel: event.target.value,
    });
  }

  const onImageChange = (event) => {
    uiPopupDispatch({
      selectedImageModel: event.target.value,
    });
  }

  const isCustomModel = selectedChatModel === "custom";

  return (
    <div className="mb-1 flex flex-col flex--top gap-05">
      <div className="flex flex--start gap-2">
        <select name=""
                className={"ui-input ui-input--new ui-input--select !w-[270px] !transition-none"
                  + (!selectedChatModel ? " ass-field__input--no-value" : "")}
                value={selectedChatModel ?? ""}
                onChange={onModelChange}>
          <option value="" disabled hidden>
            Select Model
          </option>
          {selectModelItems.map((selectItem) => {
            return <option key={selectItem.value} value={selectItem.value}>{selectItem.text}</option>
          })}
        </select>
        <select name=""
                className={"ui-input ui-input--new ui-input--select !w-[270px] !transition-none"
                  + (!selectedImageModel ? " ass-field__input--no-value" : "")}
                value={selectedImageModel ?? ""}
                onChange={onImageChange}>
          <option value="" disabled hidden>
            Select Image
          </option>
          {selectImageItems.map((selectItem) => {
            return <option key={selectItem.value} value={selectItem.value}>{selectItem.text}</option>
          })}
        </select>
        <div className="flex flex-col flex--top">
          <span className="ui-radio-label nowrap">Add Reference:</span>
          <button className={"ui-radio ui-radio--small" + (!aiDisableReferenceImage ? " ui-radio--checked" : "")}
                  onClick={() => {
                    return dispatch(setAiDisableReferenceImage(!aiDisableReferenceImage))
                  }}>
            <span className="ui-radio-circle"/>
            <span className="ui-radio-text ui-radio-text--yes"><FormattedMessage id="radioButton.on"/></span>
            <span className="ui-radio-text ui-radio-text--no"><FormattedMessage id="radioButton.off"/></span>
          </button>
        </div>
      </div>
      <div className="flex flex--start gap-2">
        {isCustomModel || selectedImageModel === "custom" ? (
          <TextInput
            className={"ui-input ui-input--new ui-input--select !w-[270px]"
              + (selectedChatModel !== "custom" ? " ui-input--gray" : "")}
            name={"customChatModel"}
            value={isCustomModel ? customChatModel || "" : ""}
            disabled={selectedChatModel !== "custom"}
            onChange={(val) => uiPopupDispatch({customChatModel: val})}
            autoFocus={isCustomModel}
          />
        ) : null}
        {selectedImageModel === "custom" ? (
          <TextInput
            className={"ui-input ui-input--new ui-input--select !w-[270px]"}
            name={"customImageModel"}
            value={customImageModel || ""}
            onChange={(val) => uiPopupDispatch({customImageModel: val})}
            autoFocus
          />
        ) : null}
      </div>
    </div>
  )
}
